import { ref } from 'vue';
import { searchUserDirectory } from '@/shared/infrastructure/api/userDirectoryApi';
import { getApiErrorStatus } from '@/shared/utils/apiErrorStatus';
import { logger } from '@/infrastructure/services/LoggerService';
export const DIRECTORY_MIN_QUERY_LENGTH = 2;
export function useUserDirectorySearch() {
    const options = ref([]);
    const loading = ref(false);
    const unavailable = ref(false);
    const rateLimited = ref(false);
    /** Any other refusal: without it the picker would read as "no result" while the search failed. */
    const failed = ref(false);
    let latestRequest = 0;
    function search(query) {
        const request = ++latestRequest;
        // OPUS trims the search and answers 400 under the minimum, so " a" must not go out.
        const q = query.trim();
        if (q.length < DIRECTORY_MIN_QUERY_LENGTH) {
            options.value = [];
            unavailable.value = false;
            rateLimited.value = false;
            failed.value = false;
            loading.value = false;
            return;
        }
        loading.value = true;
        searchUserDirectory(q)
            .then((users) => {
            if (request !== latestRequest)
                return;
            unavailable.value = false;
            rateLimited.value = false;
            failed.value = false;
            options.value = users.map((user) => ({
                id: user.id,
                name: user.displayName,
                secondaryText: user.email ?? undefined,
            }));
        })
            .catch((error) => {
            if (request !== latestRequest)
                return;
            const status = getApiErrorStatus(error);
            unavailable.value = status === 503;
            rateLimited.value = status === 429;
            failed.value = !unavailable.value && !rateLimited.value;
            options.value = [];
            // Only the status: the axios error carries the request params, i.e. the typed search text (R102).
            logger.error('User directory search failed', { status });
        })
            .finally(() => {
            if (request === latestRequest)
                loading.value = false;
        });
    }
    return { options, loading, unavailable, rateLimited, failed, search };
}
